export default {
  VacationsBookingFormSlim__DEPART_DATE: "Depart",
  VacationsBookingFormSlim__FLIGHT_CAR: "Flight + Car",
  VacationsBookingFormSlim__FLIGHT_HOTEL: "Flight + Hotel",
  VacationsBookingFormSlim__FLIGHT_HOTEL_CAR: "Flight + Hotel + Car",
  VacationsBookingFormSlim__FROM: "From",
  VacationsBookingFormSlim__PROMO_CODE: "Promo code",
  VacationsBookingFormSlim__RETURN_DATE: "Return",
  VacationsBookingFormSlim__TO: "To",
  VacationsBookingFormSlim__CHOOSE_PACKAGE_LABEL: "Choose a package",
  VacationsBookingFormSlim__CHOOSE_PACKAGE_RADIO_BUTTON_ARIA_LIVE: (data) =>
    `Choose a package radio button group. ${data.option} option selected. ${data.index} of ${data.length}`,
};
